import React from 'react';
import ParallaxSection from './ParallaxSection';
import { Accordion, AccordionItem } from './Accordion';
import { useScrollToContact } from '../hooks/useScrollToContact';

const Introduction: React.FC = () => {
  const scrollToContact = useScrollToContact();

  return (
    <ParallaxSection 
      id="ueber-uns" 
      backgroundImage="/images/Flugsportverein_Bilder_1.jpg"
    >
      <div className="text-center">
        <div className="mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-4">
            Vor den Toren des
            <span className="block text-blue-600 mt-2">Nationalparks Hainich</span>
          </h2>
          <div className="flex items-center justify-center mb-6">
            <div className="h-1 w-16 bg-blue-600 rounded-full mr-4"></div>
            <p className="text-xl md:text-2xl text-gray-600 font-medium px-4">
              In Bad Langensalza Zuhause
            </p>
            <div className="h-1 w-16 bg-blue-600 rounded-full ml-4"></div>
          </div>
          
          <div className="bg-white/90 backdrop-blur-sm rounded-lg p-6 max-w-md mx-auto shadow-lg">
            <p className="text-2xl font-semibold text-gray-800 mb-2">
              Fast 100 Mitglieder
            </p>
            <p className="text-lg text-blue-600 font-medium">
              eine Leidenschaft
            </p>
          </div>
        </div>
        
        <div className="mt-8 max-w-4xl mx-auto">
          <Accordion className="text-left">
            <AccordionItem title="Mehr über unsere Geschichte">
              <div className="text-gray-700 space-y-4 leading-relaxed">
                <h4 className="text-lg font-semibold text-gray-800 mb-3">Die Anfänge des Flugplatzes (1927-1945)</h4>
                <p>
                  Die Geschichte unseres Flugplatzes reicht weit zurück: Bereits 1927 wurde der Flugplatz Langensalza errichtet. Im Zuge der Aufrüstung der Wehrmacht baute die Luftwaffe das Gelände in den Jahren 1937/38 erheblich aus. Hier wurden DFS 230-Lastensegler getestet und verschiedene militärische Einheiten stationiert.
                </p>
                <p>
                  Von 1940 bis 1945 war der Fliegerhorst Heimat für Sturzkampfbombereinheiten, Nachtjäger vom Typ Ju 88-G6 sowie größere Ausbildungseinheiten. Besonders bedeutsam waren die hier stationierten Geschwader wie das II./St.G. 163, III./St.G. 2 und I./NJG 2. Am 7. April 1945 wurde der Fliegerhorst durch eine Panzerdivision der US Army besetzt und bis Juli 1945 als Advanced Landing Ground ALG R-2 genutzt.
                </p>
                
                <h4 className="text-lg font-semibold text-gray-800 mb-3 mt-6">DDR-Zeit und zivile Nutzung</h4>
                <p>
                  Nach dem Krieg erfolgte zunächst die totale Demontage der militärischen Anlagen. Über viele Jahre in der DDR wurde das Gelände des ehemaligen "Fliegerhorstes" als Agrarflugplatz genutzt. Hier flog zeitweise auch die legendäre AN-2, und sowohl Segelflug der GST als auch Modellflug im Rahmen einer Arbeitsgemeinschaft fanden hier statt.
                </p>
                <p>
                  Unser Flugsportverein war schon zu DDR-Zeiten der Anlaufpunkt für Kinder, Jugendliche und jung gebliebene Erwachsene, die ihre Leidenschaft für die Fliegerei entdeckten.
                </p>
                
                <h4 className="text-lg font-semibold text-gray-800 mb-3 mt-6">Neubeginn nach der Wende</h4>
                <p>
                  Die Gründung des Vereins unter seinem jetzigen Namen erfolgte 1990, so dass wir 2010 unser 20-jähriges Bestehen feiern konnten. Mit viel Elan, Ausdauer, Einfallsreichtum und Enthusiasmus haben unsere Mitglieder des Flugsportvereins Bad Langensalza ein modernes Fluggelände geschaffen, welches sich sehen lassen kann!
                </p>
                <p>
                  Heute ist der Flugplatz Langensalza (ICAO-Code: EDEB) als Sonderlandeplatz klassifiziert. Im Norden ist landwirtschaftlich genutzte Fläche, im Süden starten und landen die Segel- und Motorflugzeuge.
                </p>
              </div>
            </AccordionItem>
          </Accordion>
        </div>

        <div className="mt-12">
          <a
            href="#kontakt"
            onClick={scrollToContact}
            className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-lg shadow-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 transition-all duration-200 transform hover:scale-105"
          >
            Interesse geweckt? Kontaktieren Sie uns für einen Gastflug!
          </a>
        </div>
      </div>
    </ParallaxSection>
  );
};

export default Introduction; 